import {getJson} from './request'


export default class SubscribeCategory {

	constructor() {

	}

	static isUserSubscribeCategory(categoryMain, categorySub) {
		return new Promise((resolve, reject) => {
			getJson(`/api/article/isSubscribe/${categoryMain}/${categorySub}`).then(response => {
				//console.log('is subscribe', response);
				resolve(response.isSubscribe);
			}).catch(error => {
				reject(error)
			})
		})
	}

	static subscribe(categoryMain) {
		return new Promise((resolve, reject) => {
			//console.log('subscribe start')
			getJson(`/api/article/subscribe/${categoryMain}/0`).then(response => {
				//console.log('subscribe finish', response)
				resolve(response);
			}).catch(error => {
				reject(error)
			})
		})
	}

	static subscribeManager() {

	}

}



/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/subscribe-category.js
 **/